import React, { useContext, useEffect } from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'
import Inventory from '../views/inventory/Inventory'
import Orders from '../views/Orders/Orders'
import PasswordRecovery from '../views/passwordRecovery/PasswordRecovery'
import Liquidate from '../views/liquidate/Liquidate'
import routes from './routes'
import ProtectedRoute from './ProtectedRoute'
import Layout from '../views/layout/Layout'
import { FeatureContext } from '../context/useFeatureFlagContext'
import MassiveUpload from '../views/product/masssiveUpload/MassiveUpload'
import IndividualUpload from '../views/product/individualUpload/IndividualUpload'
import Payment from '../views/payment/payment'
import QrPayment from '../views/payment/qrPayment'
import SuccessPayment from '../views/payment/successfulPayment'
import VoucherScreen from '../views/Orders/VoucherScreen'
import HasVoucherScreen from '../views/Orders/HasVoucherScreen'
import Configurations from '../views/configurations/Configurations'
import EcoFriendSurvey from '../views/configurations/EcoFriendSurvey'
import EcoFriendCommerce from '../views/configurations/EcoFriendCommerce'
import SalesOfMonth from '../views/sales/SalesOfMonth'
import SalesDetails from '../views/salesDetails/SalesDetails'
import TokensProvider from '../context/tokensContext'
import StoreConfigurationScreen from '../views/configurations/StoreConfigurationScreen'
import ViewStoreConfigurationScreen from '../views/configurations/ViewStoreConfigurationScreen'
import Scheduled from '../views/configurations/Scheduled'
import AppLink from '../views/applinks/AppLink'
import OnlineStoreInformationScreen from '../views/configurations/OnlineStoreInformationScreen'
import OptionOnlineStoreScreen from '../views/configurations/OptionOnlineStoreScreen'
import OnlineStoreScheduledPurchaseScreen from '../views/configurations/OnlineStoreScheduledPurchaseScreen'
import TermsConditionsOnlineStore from '../views/configurations/TermsConditionsOnlineStore'
import OnlineStoreActivatedScreen from '../views/configurations/OnlineStoreActivatedScreen'
import UrlDashboardScreen from '../views/urldashboard/UrlDashboardScreen'

import Products from '../views/product/Products'
import { getFeatureFlags } from '../services/commerce'

import BciPayment from '../views/payment/bciPayment'
import GetnetPayment from '../views/payment/getnetPayment'

import BillingScreen from '../views/configurations/Billing/BillingScreen'
import RequestProformaScreen from '../views/configurations/Proforma/RequestProformaScreen'
import PayProformaScreen from '../views/configurations/Proforma/Pay'
import ProformaCalendarScreen from '../views/configurations/Proforma/ProformaCalendarScreen'
// import { Terminal } from '../views/terminal/terminal'
import { Ecommerce } from '../views/ecommerce/ecommerce'
import { Analysis } from '../views/analysis/analysis'
import { Promotions } from '../views/promotions/promotions'
import { Settlement } from '../views/settlement/settlement'
import CommunicationChannel from '../views/configurations/Communication/CommunicationChannel'
import Chat from '../views/configurations/Chat/Chat'

import SubscriptionScreen from '../views/suscriptions/SubscriptionScreen'
import SubscriptionDetail from '../views/suscriptions/SubscriptionDetail'
import { Delivery } from '../views/delivery/delivery'
import { Marketplace } from '../views/marketplace/marketplace'
import CreatePromotion from '../views/promotions/CreatePromotion'
import CreateInStorePromotion from '../views/promotions/CreateInStorePromotion'
import PromotionCreated from '../views/promotions/PromotionCreated'
import PromotionMain from '../views/promotions/PromotionMain'
import BillingMain from '../views/billing/BillingMain'
import BillingDocument from '../views/billing/BillingDocument'
import BillingDocumentExtended from '../views/billing/BillingDocumentExtended'
import { BillingData } from '../views/configurations/Billing/BillingData'
import { BillingDetails } from '../views/configurations/Billing/BillingDetails'
import { BillingPaymentData } from '../views/configurations/Billing/BillingPaymentData'
import StoreProfileMain from '../views/profiling/StoreProfileMain'
// import { MySubscription } from '../views/suscriptions/MySubscription'
import StoreMain from '../views/configurations/store/StoreMain'
import HomeRouter from '../views/home/HomeRouter'
import Home from '../views/home/Home'
import { isAdmin } from '../Utils/Profile'
import CashPayment from '../views/payment/cashPayment'
import { Impulsa } from '../views/impulsa/impulsa'

// import Login from '../views/login/Login'
import { CartScreen } from '../views/cart/cart'
import LoginMantenedor from '../views/login/LoginMantenedor'
import MyPlan from '../views/plans/MyPlan'
import { MySubscription } from '../views/suscriptions/MySubscription'
import ReportScreen from '../views/report/ReportScreen'
import ChangePassword from '../views/changePassword/ChangePassword'
import PosPayment from '../views/payment/posPayment'

export default function Router() {
    const { features, updateFeature } = useContext(FeatureContext)

    useEffect(() => {
        getFeatureFlags().then((res) => {
            updateFeature(res)
        })
    }, [])

    return (
        <Routes>
            {/* <Route path={routes.login} element={<Login />} /> */}
            <Route path={routes.login} element={<LoginMantenedor />} />
            <Route
                path={routes.passwordRecovery}
                element={<PasswordRecovery />}
            />
            <Route path={routes.chat} element={<Chat />} />
            <Route path={routes.appLinks} element={<AppLink />} />
            <Route
                path={routes.home}
                element={
                    <ProtectedRoute>
                        <Layout>
                            <Outlet />
                        </Layout>
                    </ProtectedRoute>
                }
            >
                <Route index element={<HomeRouter />} />
                <Route path={routes.localMain} element={<Home />} />

                <Route
                    path={routes.storeProfileMain}
                    element={<StoreProfileMain />}
                />

                {/* {features.marketplace && ( */}
                {/*TODO Cambiar cuando esten los planes en prod*/}

                <>
                    <Route path={routes.products} element={<Outlet />}>
                        <Route index element={<Products />} />
                        <Route
                            path={routes.massiveUpload}
                            element={<MassiveUpload />}
                        />
                        <Route
                            path={routes.individualUpload}
                            element={<IndividualUpload />}
                        />
                        <Route
                            path={routes.liquidate}
                            element={<Liquidate />}
                        />
                    </Route>
                    <Route path={routes.orders} element={<Orders />} />
                </>
                {/* )} */}
                <Route path={routes.payment} element={<Payment />} />
                <Route path={routes.posPayment} element={<PosPayment />} />

                <Route path={routes.qr} element={<QrPayment />} />
                <Route path={routes.bci} element={<BciPayment />} />
                <Route path={routes.getnet} element={<GetnetPayment />} />
                <Route
                    path={routes.successPayment}
                    element={<SuccessPayment />}
                />
                <Route path={routes.cashPayment} element={<CashPayment />} />

                <Route path={routes.sales} element={<Outlet />}>
                    <Route
                        index
                        element={
                            <TokensProvider>
                                <SalesOfMonth />
                            </TokensProvider>
                        }
                    />
                    <Route
                        path={routes.salesDetails}
                        element={
                            <TokensProvider>
                                <SalesDetails />
                            </TokensProvider>
                        }
                    />
                </Route>
                <Route path={routes.inventory} element={<Outlet />}>
                    <Route index element={<Inventory />} />
                    <Route path={routes.edit} element={<IndividualUpload />} />
                </Route>
                <Route
                    path={routes.voucherScreen}
                    element={<VoucherScreen />}
                />
                <Route
                    path={routes.hasVoucherScreen}
                    element={<HasVoucherScreen />}
                />
                <Route
                    path={routes.configurations}
                    element={<Configurations />}
                />
                <Route
                    path={routes.ecofriendSurvey}
                    element={<EcoFriendSurvey />}
                />
                <Route
                    path={routes.ecofriendCommerce}
                    element={<EcoFriendCommerce />}
                />
                <Route path={routes.billing} element={<BillingScreen />} />
                <Route
                    path={`${routes.billing}/${routes.billingMain}`}
                    element={<BillingMain />}
                />
                <Route
                    path={routes.billingDocument}
                    element={<BillingDocument />}
                />
                <Route
                    path={routes.billingDocumentExtended}
                    element={<BillingDocumentExtended />}
                />
                <Route
                    path={`${routes.billing}/data`}
                    element={<BillingData />}
                />
                <Route
                    path={`${routes.billing}/payment/data`}
                    element={<BillingPaymentData />}
                />
                <Route
                    path={`${routes.billing}/details`}
                    element={<BillingDetails />}
                />
                <Route
                    path={`${routes.billing}/${routes.requestProforma}`}
                    element={<RequestProformaScreen />}
                />
                <Route
                    path={`${routes.billing}/payment/${routes.payProforma}`}
                    element={<PayProformaScreen />}
                />
                <Route
                    path={`${routes.billing}/${routes.requestProforma}/${routes.calendar}`}
                    element={<ProformaCalendarScreen />}
                />

                <Route
                    path={routes.communication}
                    element={<CommunicationChannel />}
                />
                <Route
                    path={routes.subscription}
                    element={<SubscriptionScreen />}
                />
                <Route
                    path={`${routes.subscription}/${routes.subscriptionDetail}`}
                    element={<SubscriptionDetail />}
                />
                <Route
                    path={`${routes.communication}/${routes.chat}`}
                    element={<Chat />}
                />

                <Route
                    path={routes.storeConfigurations}
                    element={
                        isAdmin() ? (
                            <StoreConfigurationScreen />
                        ) : (
                            <ViewStoreConfigurationScreen />
                        )
                    }
                />
                <Route path={routes.storeMain} element={<StoreMain />} />

                <Route path={routes.scheduled} element={<Scheduled />} />
                <Route
                    path={routes.onlineStoreInformationScreen}
                    element={<OnlineStoreInformationScreen />}
                />
                <Route
                    path={routes.optionOnlineStore}
                    element={<OptionOnlineStoreScreen />}
                />
                <Route
                    path={routes.scheduledOnlineStore}
                    element={<OnlineStoreScheduledPurchaseScreen />}
                />
                <Route
                    path={routes.termsAndConditions}
                    element={<TermsConditionsOnlineStore />}
                />
                <Route
                    path={routes.onlineStoreActivated}
                    element={<OnlineStoreActivatedScreen />}
                />
                {features.reports && (
                    <Route
                        path={routes.urlDashboard}
                        element={<UrlDashboardScreen />}
                    />
                )}
                <Route path="e-commerce" element={<Ecommerce />} />
                {/* <Route path="terminal" element={<Terminal />} /> */}
                <Route path="analysis" element={<Analysis />} />
                <Route path={routes.impulsa} element={<Impulsa />} />
                <Route path={routes.promotions} element={<Promotions />} />
                <Route
                    path={routes.createPromotion}
                    element={<CreatePromotion />}
                />
                <Route
                    path={`${routes.createPromotion}/${routes.createPromotionDate}`}
                    element={<CreateInStorePromotion />}
                />
                <Route
                    path={`${routes.createPromotion}/${routes.createPromotionDate}/${routes.promotionCreated}`}
                    element={<PromotionCreated />}
                />
                <Route
                    path={`${routes.promotionMain}`}
                    element={<PromotionMain />}
                />

                <Route path="settlement" element={<Settlement />} />
                <Route path="delivery" element={<Delivery />} />
                <Route path="marketplace" element={<Marketplace />} />
                {/* <Route path="my-subscriptions" element={<MySubscription />} /> */}

                <Route path={routes.cart} element={<CartScreen />} />
                <Route path="my-subscriptions" element={<MySubscription />} />
                <Route path={routes.myPlan} element={<MyPlan />} />
                <Route path={routes.report} element={<ReportScreen />} />
                <Route path={routes.changePass} element={<ChangePassword />} />
            </Route>
        </Routes>
    )
}
